import { SENSOR_TYPE_UNITS_MAP, SensorType } from '@innovyze/shared-utils';
export const pressureOptions = (t) => getOptions(t, SensorType.Pressure, ['m']);
export const flowRateOptions = (t) => getOptions(t, SensorType.FlowRate);
export const headOptions = (t) => getOptions(t, SensorType.Head);
export const volumeOptions = (t) => ['ft3', 'm3'].map(unit => ({
    value: unit,
    label: t(unit),
}));
export const levelOptions = (t) => getOptions(t, SensorType.Level);
export const powerOptions = (t) => getOptions(t, SensorType.Power);
export const efficiencyOptions = (t) => getOptions(t, SensorType.Percent);
const getOptions = (t, sensorType, excludeUnits = []) => {
    if (sensorType === SensorType.Ratio) {
        // Property '[SensorType.Ratio]' does not exist in SENSOR_TYPE_UNITS_MAP
        return [];
    }
    excludeUnits.push('No Units'); // always exclude 'No Units'
    const options = SENSOR_TYPE_UNITS_MAP[sensorType]
        .filter(unit => !excludeUnits.includes(unit))
        .map(unit => ({
        value: unit,
        label: t(unit),
    }));
    return options;
};
